import { render, staticRenderFns } from "./MyCommunity.vue?vue&type=template&id=093db83d&scoped=true"
import script from "./MyCommunity.vue?vue&type=script&lang=js"
export * from "./MyCommunity.vue?vue&type=script&lang=js"
import style0 from "./MyCommunity.vue?vue&type=style&index=0&id=093db83d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093db83d",
  null
  
)

export default component.exports